import { motion } from 'framer-motion';
import { useReveal } from '../components/useReveal';

const testimonials = [
  {
    text: 'Vimal built our ERP system from scratch and it completely changed how we manage our business. Everything is organized, fast, and easy to use. He understood our needs perfectly.',
    name: 'ST Gold Covering Co.',
    role: 'ERP System Client',
    initial: 'S',
  },
  {
    text: 'The e-commerce website Vimal delivered was professional, fast, and exactly what we needed. Orders started coming in right from launch day. Great work and reliable communication.',
    name: 'E-commerce Client',
    role: 'WordPress Store Owner',
    initial: 'E',
  },
  {
    text: 'He handles our social media and digital marketing and has genuinely grown our online presence. Our enquiries have increased noticeably since he took over. Highly recommended.',
    name: 'Business Owner',
    role: 'Digital Marketing Client',
    initial: 'B',
  },
];

export default function Testimonials() {
  const { ref, controls, variants } = useReveal();

  return (
    <section id="testimonials" style={{ background: 'var(--black)', padding: '130px 80px' }}>

      <motion.div ref={ref} initial="hidden" animate={controls} variants={variants} className="section-header">
        <span className="section-num">04</span>
        <div className="section-line" />
        <h2 className="section-title">Client <em>Words</em></h2>
      </motion.div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }} className="testimonials-grid">
        {testimonials.map((t, i) => <TestCard key={i} t={t} delay={i * 0.1} />)}
      </div>

      <style>{`
        .testimonials-grid { grid-template-columns: repeat(3, 1fr); }
        @media (max-width: 1000px) { .testimonials-grid { grid-template-columns: 1fr !important; } }
        @media (max-width: 900px) { section#testimonials { padding: 90px 24px !important; } }
      `}</style>
    </section>
  );
}

function TestCard({ t, delay }) {
  const { ref, controls, variants } = useReveal();
  return (
    <motion.div
      ref={ref} initial="hidden" animate={controls}
      variants={{ ...variants, visible: { ...variants.visible, transition: { ...variants.visible.transition, delay } } }}
      style={{ padding: '44px 40px', border: '1px solid var(--border)', background: 'var(--panel)', position: 'relative', transition: 'border-color .3s' }}
      onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(201,169,110,0.2)'}
      onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
    >
      {/* Big quote mark */}
      <div style={{ position: 'absolute', top: '20px', right: '28px', fontFamily: "'Cormorant Garamond', serif", fontSize: '90px', color: 'rgba(201,169,110,0.08)', lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>"</div>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '19px', fontWeight: 300, color: 'rgba(245,240,232,0.8)', lineHeight: 1.7, marginBottom: '36px' }}>{t.text}</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
        <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: 'linear-gradient(135deg, #c9a96e, rgba(201,169,110,0.3))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '15px', color: '#080808', flexShrink: 0 }}>
          {t.initial}
        </div>
        <div>
          <div style={{ fontSize: '13px', fontWeight: 500, marginBottom: '2px' }}>{t.name}</div>
          <div style={{ fontSize: '10px', letterSpacing: '0.18em', textTransform: 'uppercase', color: '#c9a96e' }}>{t.role}</div>
        </div>
      </div>
    </motion.div>
  );
}
